import React, { useContext } from 'react';
import { FormContext, FormSchemaFields } from '@stormwater-software/lib-form';
import { UIControlType } from '@stormwater-software/lib-form-control-types';
import { toast } from 'react-toastify';
import FormModal from '../../Shared/form/modal/FormModal';
import reportApi from '../../../utils/api/report';

const SCOPE_OPTIONS = [
  { id: 'all', name: 'All Projects' },
  { id: 'pending', name: 'Pending' },
  { id: 'archived', name: 'Archived' },
];

const RANGE_OPTIONS = [
  { id: 'all_till_date', name: 'All till Date' },
  { id: 'ytd', name: 'Year to date' },
  { id: 'q1', name: 'Q1 (Jan–Mar)' },
  { id: 'q2', name: 'Q2 (Apr–Jun)' },
  { id: 'q3', name: 'Q3 (Jul–Sep)' },
  { id: 'q4', name: 'Q4 (Oct–Dec)' },
  { id: 'custom', name: 'Custom range' },
];

// Custom start/end pickers only appear when range === 'custom' (TC-20).
const getSchema = (range: string) => {
  const schema: any = {
    scope: {
      controlType: UIControlType.select,
      label: 'Project scope',
      options: SCOPE_OPTIONS,
      valueKey: 'id',
      labelKey: 'name',
      validation: { required: true },
    },
    range: {
      controlType: UIControlType.select,
      label: 'Date range',
      options: RANGE_OPTIONS,
      valueKey: 'id',
      labelKey: 'name',
      validation: { required: true },
    },
  };

  if (range === 'custom') {
    schema.start = {
      controlType: UIControlType.date,
      label: 'Start date',
      style: { flex: '0 1 50%' },
      validation: { required: true, maxDate: new Date() },
    };
    schema.end = {
      controlType: UIControlType.date,
      label: 'End date',
      style: { flex: '0 1 50%' },
      validation: { required: true, maxDate: new Date() },
    };
  }

  return schema;
};

const HubspotReportModal = ({ setShowModal }: { setShowModal: Function }) => {
  const formContext = useContext(FormContext);

  const submit = async () => {
    const { scope, range, start, end } = formContext.value;

    const res = await reportApi.generateHubspotReport({
      scope: scope || 'all',
      range: range || 'ytd',
      ...(range === 'custom' && { start, end }),
    });

    // Async by design: no inline table — confirm the emailed-link flow (TC-30).
    toast.success(
      res?.message ||
        "Your HubSpot report is generating. We'll email you a download link when it's ready.",
    );
    setShowModal(false);
  };

  return (
    <FormModal
      onSubmit={submit}
      onCancel={() => setShowModal(false)}
      modalProps={{
        title: 'Generate HubSpot Report',
        submitBtnText: 'Generate',
      }}
    >
      <section className='hubspot-report-form'>
        <p className='hubspot-report-form__hint'>
          The report runs in the background. You'll receive an email with a secure,
          expiring download link when it's ready.
        </p>
        <FormSchemaFields
          schema={getSchema(formContext.value.range)}
          onChange={formContext.set}
          formData={formContext.value}
          initialFormData={formContext.value}
        />
      </section>
    </FormModal>
  );
};

export default HubspotReportModal;
